const PROFILE_UPDATE_TOOLS = new Set([
  "m365_update_contact_info",
  "m365_update_organizational_info",
  "m365_update_personal_information",
]);

/**
 * Aligns HITL accordion titles with onboarding workflow wording ("Set contact info", etc.)
 * by replacing the verb "Update" with "Set" in LLM-generated ai_descriprion text.
 */
export function formatHitlToolDescription(toolName: string, description: string): string {
  const text = String(description ?? "");
  if (!PROFILE_UPDATE_TOOLS.has(String(toolName || ""))) return text;
  return text.replace(/\bUpdate\b/g, "Set");
}
